"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveLeaderboardDropHeader } from "./header/WaveLeaderboardDropHeader";
import { WaveLeaderboardDropContent } from "../content/WaveLeaderboardDropContent";
import { WaveLeaderboardDropFooter } from "./footer/WaveLeaderboardDropFooter";
import { ApiWave } from "@/generated/models/ObjectSerializer";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { WaveLeaderboardDropRaters } from "./header/WaveleaderboardDropRaters";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import { VotingModal, MobileVotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
interface DefaultWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const DefaultWaveLeaderboardDrop: React.FC<DefaultWaveLeaderboardDropProps> = t0 => {
  const $ = _c(61);
  const {
    drop,
    wave,
    onDropClick
  } = t0;
  const {
    canShowVote,
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const isMobileScreen = useIsMobileScreen();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  let t2;
  if ($[2] !== drop.rank) {
    t2 = () => {
      const rank = drop.rank && drop.rank <= 3 ? drop.rank : "default";
      if (rank === 1) {
        return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-[#fbbf24]/40";
      } else {
        if (rank === 2) {
          return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-[#94a3b8]/40";
        } else {
          if (rank === 3) {
            return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-[#CD7F32]/40";
          } else {
            return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-iron-700";
          }
        }
      }
    };
    $[2] = drop.rank;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getBorderClasses = t2;
  let t3;
  if ($[4] !== drop || $[5] !== onDropClick) {
    t3 = () => onDropClick(drop);
    $[4] = drop;
    $[5] = onDropClick;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = getBorderClasses();
  let t5;
  if ($[7] !== drop) {
    t5 = <WaveLeaderboardDropHeader drop={drop} />;
    $[7] = drop;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== drop) {
    t6 = <div className="tw-h-8 tw-hidden lg:tw-block"><WaveDropActionsOpen drop={drop} /></div>;
    $[9] = drop;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== canDelete || $[12] !== drop) {
    t7 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[11] = canDelete;
    $[12] = drop;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div className="tw-h-8 tw-hidden lg:tw-block">{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div className="tw-flex tw-items-center">{t6}{t8}</div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t9) {
    t10 = <div className="tw-flex tw-flex-col tw-gap-3"><div className="tw-flex tw-items-center tw-justify-between tw-gap-4">{t5}{t9}</div></div>;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== drop) {
    t11 = <div className="tw-space-y-2"><div className="tw-ml-[3.35rem]"><WaveLeaderboardDropContent drop={drop} isCompetitionDrop={true} /></div></div>;
    $[22] = drop;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== drop) {
    t12 = <WaveLeaderboardDropRaters drop={drop} />;
    $[24] = drop;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== drop || $[27] !== wave) {
    t13 = <WaveLeaderboardDropFooter drop={drop} wave={wave} />;
    $[26] = drop;
    $[27] = wave;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-y-2 tw-gap-x-4">{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== canShowVote || $[33] !== drop) {
    t15 = canShowVote && <div className="tw-flex tw-justify-center tw-pt-4 @[700px]:tw-pt-0 @[700px]:tw-ml-auto tw-border-t tw-border-iron-800 tw-border-solid tw-border-x-0 tw-border-b-0 @[700px]:tw-border-t-0" onClick={_temp}><VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} /></div>;
    $[32] = canShowVote;
    $[33] = drop;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15) {
    t16 = <div className="tw-mt-3 tw-inline-flex tw-flex-col @[700px]:tw-flex-row tw-justify-between @[700px]:tw-items-center sm:tw-ml-[3.25rem] tw-space-y-3 @[700px]:tw-space-y-0 tw-gap-x-2">{t14}{t15}</div>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t10 || $[39] !== t11 || $[40] !== t16) {
    t17 = <div className="tw-flex tw-flex-col">{t10}{t11}{t16}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t17 || $[43] !== t4 || $[44] !== touchHandlers) {
    t18 = <div className={t4} {...touchHandlers}>{t17}</div>;
    $[42] = t17;
    $[43] = t4;
    $[44] = touchHandlers;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== drop || $[47] !== isMobileScreen || $[48] !== isVotingModalOpen) {
    t19 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[46] = drop;
    $[47] = isMobileScreen;
    $[48] = isVotingModalOpen;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== canDelete || $[51] !== drop || $[52] !== hasTouchScreen || $[53] !== isActive || $[54] !== setIsActive) {
    t20 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[50] = canDelete;
    $[51] = drop;
    $[52] = hasTouchScreen;
    $[53] = isActive;
    $[54] = setIsActive;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t18 || $[57] !== t19 || $[58] !== t20 || $[59] !== t3) {
    t21 = <div onClick={t3} className="tw-@container tw-group tw-cursor-pointer tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-w-full tw-relative">{t18}{t19}{t20}</div>;
    $[56] = t18;
    $[57] = t19;
    $[58] = t20;
    $[59] = t3;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  return t21;
};
function _temp(e) {
  return e.stopPropagation();
}